<!--
 * @Author: your name
 * @Date: 2022-03-08 08:50:12
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-26 08:43:02
 * @Description: file content
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- 加载中 -->
    <Loading />
    <!-- 设置昵称弹窗 -->
    <SetNickName />
    <!-- 分享海报弹窗 -->
    <SharePoster />
    <!-- 加价弹窗 -->
    <ShareGoods />
  </div>
</template>
<script>
  import Loading from "@/components/Loading";
  import SetNickName from "@/components/SetNickName";
  import browserType from "@/utils/browserType";
  import browserTypeAdapter from "@/utils/browserTypeAdapter";
  import SharePoster from "@/components/sharePoster/index";
  import ShareGoods from "@/components/sharePoster/goods";

  export default {
    components: { Loading, SetNickName, SharePoster, ShareGoods },
    created() {
      localStorage.setItem("browserType", browserType());
      localStorage.setItem("browserTypeAdapter", browserTypeAdapter());
      console.group("%c browserTypeAdapter", "color: #f00; font-size: 20px;");
      console.log(browserTypeAdapter());
      console.groupEnd();
    },
  };
</script>
<style>
  body,
  html,
  #app {
    height: 100%;
    width: 100%;
  }
  #app {
    font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB",
      "Microsoft YaHei", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #333;
  }

  #nav {
    padding: 30px;
  }

  #nav a {
    font-weight: bold;
    color: #333;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }
</style>
